import { Record } from 'immutable';

import { Vehicle } from '@sm360/widget-commons-vehicle';

import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';
import VehicleCriteria from 'inventory-listing/models/VehicleCriteriaModel.js';

class ListingUsed extends Record({
    lookingForFilter: '',
    sortBy: '',
    paymentOptions: new Vehicle.PaymentOptionsModel(),
    favorites: [],
    vehicleCriteria: new VehicleCriteria(),
    vehicleOrders: {},
    defaultVehicleOrders: [
        {
            vehicleSortParameter: 'SALE_PRICE',
            direction: 'ASC',
        },
    ],
    makePriorities: [],
    contextUrl: '',
    vdpUrl: '',
    carfaxKey: '',
    colanderGroup: '',
    colanderList: [],
    colanders: [],
    dealerMake: '',
    metadatas: [],
    genericDisclaimers: {},
}) {
    colanderGroupIsNew() {
        return this.colanderGroup === COLANDER_GROUPS.NEW;
    }
}

export default ListingUsed;
